import Vue from 'vue';

export const EventBus = new Vue();

export const EVENT_REFRESH_VISITS = 'EVENT_REFRESH_VISITS';
export const EVENT_REFRESH_SEARCHES = 'EVENT_REFRESH_SEARCHES';
export const EVENT_CLEAR_FILES = 'EVENT_CLEAR_FILES';
